import React from "react";
import styled from "styled-components";
import { device } from "../../../theme";

const Button = styled.button`
  min-width: 150px;
  max-width: 300px;
  position: relative;
  height: 49px;
  padding: 10px;
  gap: 10px;
  border-radius: ${(props) => props.borderRadius || "15px"};
  opacity: 0.9;
  border: 1px solid ${({ theme }) => theme.grey};
  box-shadow: ${({ theme }) => theme.boxShadow4};
  font-family: Inter, sans-serif; /* Added a fallback font-family */
  font-size: 21px;
  font-weight: 400;
  line-height: 29.05px;
  text-align: center;
  color: ${({ theme }) => theme.white};
  background-color: ${({ theme }) => theme.blue};
  outline: none;
  cursor: pointer;
  transition: opacity 0.2s linear;

  &:hover {
    opacity: 0.7;
  }

  @media ${device.laptopL} {
    font-size: 20px;
    line-height: 27px;
  }

  @media ${device.laptop} {
    font-size: 18px;
    line-height: 24px;
  }

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 22px;
  }

  @media ${device.mobileL} {
    font-size: 14px;
    line-height: 20px;
  }

  @media ${device.mobileM} {
    font-size: 12px;
    line-height: 18px;
  }

  @media ${device.mobileS} {
    font-size: 11px;
    line-height: 16px;
  }
`;

const RoundedFilledButton = ({
  btnText,
  handleClick,
  borderRadius,
  type,
  loading,
}) => {
  return (
    <Button
      type={type}
      onClick={(e) => {
        e.preventDefault();
        handleClick && handleClick();
      }}
      borderRadius={borderRadius}
    >
      {loading ? "Loading..." : btnText}
    </Button>
  );
};

export default RoundedFilledButton;
